// Generic archive load-more. Appends the next page of cards fetched from the
// g4z/v1/archive/{post_type} REST route. Post-type agnostic: every
// `.js-load-more` button carries its own post type and paging state, so any
// CPT archive can reuse this without JS changes.
(function () {
  'use strict';

  const config = window.loadMoreConfig || {};

  if (!config.restUrl) {
    return;
  }

  async function loadMore(button) {
    const section = button.closest('.c-overview');
    const grid = section && section.querySelector('.js-overview-grid');

    if (!grid) {
      return;
    }

    const postType = button.dataset.postType;
    const nextPage = parseInt(button.dataset.page, 10) + 1;
    const url = `${config.restUrl}${postType}?paged=${nextPage}`;

    button.disabled = true;
    section.classList.add('is-loading');

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Load more failed: ${response.status}`);
      }

      const data = await response.json();

      grid.insertAdjacentHTML('beforeend', data.html);
      button.dataset.page = String(nextPage);

      if (!data.has_more) {
        button.parentElement.remove();
      }
    } catch (error) {
      console.error(error);
    } finally {
      button.disabled = false;
      section.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-load-more');

    if (button) {
      loadMore(button);
    }
  });
})();
